



























































import {
    Component, Inject, Mixins, Model, Prop,
} from 'vue-property-decorator';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';
import { ProductTemplateContent } from '@/assets/interface/Product';
import { Validator } from 'vee-validate';

@Component
export default class OTextField extends Mixins(IsMobileMixin) {
    @Inject('$validator') public $validator!: Validator;

    @Model('input', { type: String }) public model!: string;

    @Prop({ default: 'Label' }) public label!: string;

    @Prop({ default: '...' }) public hint!: string;

    @Prop({ default: '' }) public name!: string;

    @Prop({ default: '' }) public validate!: string;

    @Prop({ default: 'text' }) public type!: string;
}
